import { render } from "./ImageApp.vue?vue&type=template&id=8533a050&scoped=true"
import script from "./ImageApp.vue?vue&type=script&lang=js"
export * from "./ImageApp.vue?vue&type=script&lang=js"

import "./ImageApp.vue?vue&type=style&index=0&id=8533a050&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8533a050"]])

export default __exports__